export const ANIMATION_NEW_ID = 'js-animation-new';
export const SEARCH_BAR_ID = 'js-search-bar';
